import { PORTFOLIOS, PORTFOLIOS_UPDATE } from 'client/api';
import { clientAdmin } from 'client/request';

const getPortfolio = async () => {
  // const url = portfolioId ? `${PORTFOLIOS}/${portfolioId}` : PORTFOLIOS;

  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.get(PORTFOLIOS, {});
    return res.data?.data || [];
  } catch (err) {
    throw err;
  }
};

const updatePortfolio = async (body) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.post(PORTFOLIOS_UPDATE, body);
    return res.data.data;
  } catch (err) {
    throw err;
  }
};

export default {
  getPortfolio,
  updatePortfolio
};
